import * as React from 'react'
import { FC, ReactNode } from 'react'
import Table from '@organisms/Table'
import { ListPageLayoutListProps } from '@templates/ListPageLayout'
import { Report } from '@models/reports'
import Tab from '@organs/Tabs/Tab'
import ReportType from '@enums/ReportType'
import { formatServerDate } from '@utils/date'
import ReportStatus from '@enums/ReportStatus'
import { TableWrapper } from './styled'
import DownloadReportButton from './DownloadReportButton'

const EMPLOYEES = 'Сотрудники'
const RISK_MAPS = 'Карты рисков'
const EDUCATION = 'Обучение сотрудников'
const REPORTS_CONFIG = {
  [ReportType.BodyCheck]: {
    chapter: EMPLOYEES,
  },
  [ReportType.RiskMap]: {
    chapter: RISK_MAPS,
  },
  [ReportType.RiskMapReportArchive]: {
    chapter: RISK_MAPS,
  },
  [ReportType.RiskMapDanger]: {
    chapter: RISK_MAPS,
  },
  [ReportType.RiskMapIndividualMean]: {
    chapter: RISK_MAPS,
  },
  [ReportType.RiskMapControlMeasurePlan]: {
    chapter: RISK_MAPS,
  },
  [ReportType.Employees]: {
    chapter: EMPLOYEES,
  },
  [ReportType.EmployeeProbationSheet]: {
    chapter: EMPLOYEES,
  },
  [ReportType.EducationDestinationProtocol]: {
    chapter: EDUCATION,
  },
  [ReportType.MultipleBriefing]: {
    chapter: EDUCATION,
  },
  [ReportType.RiskMapEmployeeReview]: {
    chapter: RISK_MAPS,
  },
  [ReportType.JobPositionWithoutRiskMap]: {
    chapter: RISK_MAPS,
  },
  [ReportType.ProfessionalRiskManagementSystem]: {
    chapter: RISK_MAPS,
  },
  [ReportType.MinistryLaborXlsx]: {
    chapter: EDUCATION,
  },
  [ReportType.MinistryLaborXml]: {
    chapter: EDUCATION,
  },
  [ReportType.EmployeeRecoveryLinks]: {
    chapter: EMPLOYEES,
  },
  [ReportType.InitialBriefing]: {
    chapter: EDUCATION,
  },
  [ReportType.ConductJobPosition]: {
    chapter: EDUCATION,
  },
  [ReportType.ElectricalSafetyNonElectric]: {
    chapter: EDUCATION,
  },
  [ReportType.FireSafetyBriefing]: {
    chapter: EDUCATION,
  },
} as const

const STATUS_COLOR = {
  [ReportStatus.Done]: 'green',
  [ReportStatus.New]: 'gray',
  [ReportStatus.InProgress]: 'orange',
  [ReportStatus.Error]: 'red',
}

enum TABLE_FIELDS {
  CHAPTER = 'CHAPTER',
  TITLE = 'TITLE',
  GENERATED_DATE = 'GENERATED_DATE',
  STATUS = 'STATUS',
  WILL_DELETE_DATE = 'WILL_DELETE_DATE',
  ACTION = 'ACTION',
}

const COLUMNS = [
  {
    title: 'Раздел',
    dataIndex: TABLE_FIELDS.CHAPTER,
  },
  {
    title: 'Название отчета',
    dataIndex: TABLE_FIELDS.TITLE,
  },
  {
    title: 'Дата генерации',
    dataIndex: TABLE_FIELDS.GENERATED_DATE,
    width: 100,
  },
  {
    title: 'Статус',
    dataIndex: TABLE_FIELDS.STATUS,
    width: 165,
  },
  {
    title: 'Будет удален',
    dataIndex: TABLE_FIELDS.WILL_DELETE_DATE,
    width: 100,
  },
  {
    title: 'Действие',
    dataIndex: TABLE_FIELDS.ACTION,
    width: 100,
  },
]

export type DataItem = {
  key: string
  id: string
} & { [key in TABLE_FIELDS]: ReactNode | undefined }

type Props = ListPageLayoutListProps<Report>

const WorkPlacesTable: FC<Props> = ({
  list,
  setPage,
  length,
  isLoading,
  perPage,
}) => {
  const tableData: DataItem[] = []
  for (const {
    '@id': id,
    type,
    typeCaption,
    createdAt,
    status,
    statusCaption,
    expiredAt,
    reportFile,
  } of list) {
    tableData.push({
      id,
      key: id,
      [TABLE_FIELDS.CHAPTER]: REPORTS_CONFIG[type]?.chapter,
      [TABLE_FIELDS.TITLE]: typeCaption,
      [TABLE_FIELDS.GENERATED_DATE]: formatServerDate(createdAt, true),
      [TABLE_FIELDS.STATUS]: (
        <Tab
          badgeColor={STATUS_COLOR[status]}
          id="id"
          tabSize="small"
          title={statusCaption}
        />
      ),
      [TABLE_FIELDS.WILL_DELETE_DATE]: formatServerDate(expiredAt),
      [TABLE_FIELDS.ACTION]: (
        <DownloadReportButton status={status} reportFile={reportFile} />
      ),
    })
  }

  return (
    <TableWrapper>
      <Table
        columns={COLUMNS}
        data={tableData}
        loading={isLoading}
        pagination={{
          position: ['bottomLeft'],
          onChange: setPage,
          total: length,
          showSizeChanger: false,
          pageSize: perPage,
        }}
      />
    </TableWrapper>
  )
}

export default WorkPlacesTable
